import React from "react";
import { StatsWidgetTemplate } from "themes/administration/analytics/components";

function StatsWidget(props) {
    return <StatsWidgetTemplate {...props} />;
}

export default StatsWidget;
